import styled from 'styled-components';
import { token } from '@zillow/constellation';

// Constellation
import { Text } from '@zillow/constellation';

export const Window = styled.div`
  background: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5);
  width: 136px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px;
`;

export const InfoThumbContainer = styled.div`
  display: flex;
  height: 48px;
  width: 48px;
  background: ${token('colors.gray300')};
  justify-content: center;
  align-items: center;
  margin-right: 8px;
`;

export const Thumbnail = styled.img`
  height: 48px;
  width: 48px;
  object-fit: cover;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DetailsText = styled(Text)`
  line-height: 16px !important;
`;

export const HomeDot = styled.div`
  pointer-events: auto;
`;
